export const convertTimeToUtc = 1000;
export const oneSecond = 1000;
